// extracted by mini-css-extract-plugin
export var image = "fS_b4";